import useCurrentNotebook from "../use-current-notebook";
import { currentPageAtom } from "utilities/atoms/notebooks-atom";
import { useCallback, useEffect } from "react";
import { useSetAtom } from "jotai";

interface UseSetCurrentPageOptions {
    pageId: number | null;
}

const useSetCurrentPage = (options: UseSetCurrentPageOptions) => {
    const { pageId } = options;
    const setCurrentPageAtom = useSetAtom(currentPageAtom);
    const { currentNotebook } = useCurrentNotebook();

    const setCurrentPage = useCallback(() => {
        if (pageId == null) {
            setCurrentPageAtom(null);
            return;
        }

        const page =
            currentNotebook?.pages?.find((p) => p.id === pageId) ?? null;

        setCurrentPageAtom(page);
    }, [currentNotebook?.pages, pageId, setCurrentPageAtom]);

    useEffect(() => {
        setCurrentPage();
    }, [setCurrentPage]);

    return {};
};

export default useSetCurrentPage;
